"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assignRef = exports.startObservingTopAndBottom = exports.onIntersectingTopOrBottom = void 0;
const IntersectionObserver_1 = require("./IntersectionObserver");
/**
 *
 * @param observer intersection observer
 * @param entry entry encountered by the intersection observer
 * @param targetItemRefs a store of the refs and seen statuses for each item
 * @param onIntersectionCallback function to call when observed item is intersected
 */
const onIntersectingTopOrBottom = (observer, entry, targetItemRefs) => {
    // Get the data attributes from the encountered element
    const itemId = entry.target.getAttribute("data-itemid");
    const edge = entry.target.getAttribute("data-edge");
    // If itemid isn't defined (for whatever reason) we won't try to do anything else here
    if (itemId) {
        const currentItem = targetItemRefs[itemId];
        if (edge === "top") {
            currentItem.seenTop = true;
        }
        if (edge === "bottom") {
            currentItem.seenBottom = true;
            // If both edges are seen we can assume that the entire item has been viewed
            if (currentItem.seenTop && currentItem.seenBottom) {
                // Call onIntersectionCallback
                currentItem.onIntersectionCallback !== undefined &&
                    currentItem.onIntersectionCallback(itemId);
                const topElement = currentItem.top;
                const bottomElement = currentItem.bottom;
                // For performance - stop observing the top and bottom edges
                if (topElement !== null && bottomElement !== null) {
                    observer.unobserve(topElement);
                    observer.unobserve(bottomElement);
                }
            }
        }
    }
};
exports.onIntersectingTopOrBottom = onIntersectingTopOrBottom;
const startObservingTopAndBottom = (observer, element) => {
    if (element.top && element.bottom) {
        observer.observe(element.top);
        observer.observe(element.bottom);
    }
};
exports.startObservingTopAndBottom = startObservingTopAndBottom;
/**
 * Add a ref to the appropriate place in the store, e.g. under the key for the correct itemId, and the correct bit out of top/bottom
 * @param targetItemRefs a store of the refs for each item
 * @param element the element to add a ref for
 * @param edge which edge of the item this element is on
 * @param itemId the itemId for the relevant item
 * @return //
 */
const assignRef = (targetItemRefs, element, edge, itemId, onIntersectionCallback) => {
    // If message refs objects doesn't have anything for this itemId, then make a default object for it
    if (itemId && !targetItemRefs.hasOwnProperty(itemId)) {
        targetItemRefs[itemId] = {
            top: null,
            bottom: null,
            seenTop: false,
            seenBottom: false,
            onIntersectionCallback,
        };
    }
    if (element !== null && itemId) {
        if (edge === IntersectionObserver_1.Edge.top) {
            targetItemRefs[itemId].top = element;
        }
        if (edge === IntersectionObserver_1.Edge.bottom) {
            targetItemRefs[itemId].bottom = element;
        }
    }
};
exports.assignRef = assignRef;
//# sourceMappingURL=Thread.utils.js.map